import React, { useEffect, useState } from 'react';
import { Container, Modal, ModalBody } from 'mdbreact';
import { FormattedMessage } from 'react-intl';
import styles from './TagsFilters.module.scss';
import searchGrey from '../../../../../assets/images/search-grey.svg';

const groupTagsByLetter = (tags) => {
    const grouped = {};
    tags.forEach((tag) => {
        const letter = tag.name.charAt(0).toUpperCase();
        if (!grouped[letter]) grouped[letter] = [];
        grouped[letter].push(tag);
    });
    return grouped;
};

const TagsFilters = ({
    isOpened,
    handleClose,
    applyTags,
    preselectedTags,
    tags,
}) => {
    const [search, setSearch] = useState('');
    const [selectedTag, setSelectedTag] = useState(null);
    const [groupedTags, setGroupedTags] = useState({});

    useEffect(() => {
        if (preselectedTags !== selectedTag) {
            setSelectedTag(preselectedTags);
        }
    }, [preselectedTags]);

    useEffect(() => {
        if (tags) {
            if (preselectedTags?.length) {
                const selected = tags.filter((tag) =>
                    preselectedTags.some((preTag) => preTag === tag.id)
                );
                setSelectedTag(selected);
            }
            const filteredTags = tags.filter((tag) =>
                tag.name.toLowerCase().includes(search.toLowerCase())
            );
            setGroupedTags(groupTagsByLetter(filteredTags));
        }
    }, [tags]);

    useEffect(() => {
        if (tags) {
            const filteredTags = tags.filter((tag) =>
                tag.name.toLowerCase().includes(search.toLowerCase())
            );
            setGroupedTags(groupTagsByLetter(filteredTags));
        }
    }, [search]);

    const onChange = (e) => {
        setSearch(e.target.value);
    };

    const handleAddTag = (tag) => {
        setSelectedTag(tag.id);
        applyTags(tag.id);
    };

    return (
        <Modal
            isOpen={isOpened}
            className={styles.tagsFiltersModal}
            size="fluid"
        >
            <Container className={styles.modalContainer}>
                <ModalBody>
                    <span
                        onClick={handleClose}
                        className="modal-close modal-close--grey"
                    />
                    <h3 style={{ textTransform: 'uppercase' }}>
                        <FormattedMessage id="product_details.tags.modal_title" />
                    </h3>
                    <div className={styles.searchBox}>
                        <input
                            type="text"
                            placeholder=""
                            value={search}
                            onChange={onChange}
                        />
                        <img
                            src={searchGrey}
                            alt="search"
                            className={styles.icon}
                        />
                    </div>

                    <div className={styles.tagsGroupContainer}>
                        {Object.keys(groupedTags)
                            .sort()
                            .map((letter) => (
                                <div key={letter} className={styles.tagGroup}>
                                    <div className={styles.letter}>
                                        {letter}
                                    </div>
                                    <div className={styles.tagCloud}>
                                        {groupedTags[letter].map((tag) => (
                                            <button
                                                type="button"
                                                className={`${styles.tag} ${
                                                    selectedTag === tag?.id
                                                        ? styles.selected
                                                        : ''
                                                }`}
                                                key={tag.id}
                                                onClick={() =>
                                                    handleAddTag(tag)
                                                }
                                            >
                                                {tag.name}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                    </div>
                </ModalBody>
            </Container>
        </Modal>
    );
};

export default TagsFilters;
